import React, { useState } from 'react'
import {
  One,
  Two,
  Three,
  Four,
  Five,
  Six,
  Seven,
} from './pages/mobile'
import MintModal from './MintModal'

export default function Mobile({metamask, provider}) {  
  const [isOpen, setIsOpen] = useState(false)
  return (
    <>      
      <MintModal provider={provider} isOpen={isOpen} setIsOpen={setIsOpen} />
      <One metamask={metamask} provider={provider} isOpen={isOpen} setIsOpen={setIsOpen}  />
      <Two />
      <Three />
      <Four />
      <Five />
      <Six />
      <Seven />
    </>
  )
};
